import { FC, PropsWithChildren, ReactElement } from 'react'

import './PacoTable.scss'

interface PacoTableProps extends PropsWithChildren {
    className?: string;
}

const PacoTable: FC<PacoTableProps> = ({
    className = '',
    children,
}): ReactElement => (
    <table className={`paco-table ${className}`}>
        {children}
    </table>
)

export default PacoTable
